/*
 * Control the visibility and play-ability of the
 * HTML5 video on the U2 template and the homepage.
 *
 *
 * Assesses the state of the video and fires
 * custom event/s to let the other modules
 * know what's up
 *
 * @author BarrelNY
 *
 */

var VideoHero = {
	init:function(){
		//What templates should trigger this module?
		var templates = [
			'body.U2-template'
		].join();

		if (!$(templates).length) return;

		// Check if page is homepage
		this.isHome = $('body.home').length;

		this.$sectionContent = $('section.content');
		this.$video = $('.video-hero video');
		this.$playBtn = $('.icon-play');

		if (this.$video.length) {
			this.events();

			//Tablet/Mobile doesn't require video
			this.toggleMobileVideo();
		}

		setTimeout(function(){
			$('.video-hero-wrapper').addClass('visible');
		}, 300);
	},

	events:function(){
		$(window).on('scroll',this.checkScrollPos.bind(this));

		if (this.isHome) {
			this.$playBtn.on('click',this.play.bind(this));
			this.$video.on('click',this.pause.bind(this));
		} else {
			//Check to see if immediately ready
			if ( MUR.videoStateCheck() && !MUR.hideVideo() ){
				this.play();
			}
		}
	},

	/*
	 * Check if video section is visible,
	 * pauses if not, resumes if visible unless homepage
	 * @params	void
	 * @returns	void
	 */
	checkScrollPos:function(){
		if ( $(document).scrollTop() > this.$sectionContent.offset().top ) {
			this.pause();
		} else if (!this.isHome) {
			this.play();
		}
	},

	/*
	 * Play the video and let the rest of the
	 * modules know that the video
	 * about to be played
	 * @params	void
	 * @returns	void
	 */
	play:function(){
		if (this.isHome) {
			this.$playBtn.addClass('icon-play__hide');
		}

		this.$video.addClass('playing');
		this.$video[0].play();
	},

	/*
	 * Pause the video when it is not in view:
	 * when we have moved past the second
	 * section
	 *
	 * @params	void
	 * @returns	void
	 */
	pause:function(){
		this.$video[0].pause();

		if (this.isHome) {
			this.$playBtn.removeClass('icon-play__hide');
		}
	},

	/*
	 * Remove video on tablet and mobile, except on homepage
	 * @params	void
	 * @returns	void
	 */
	toggleMobileVideo:function(){
		if ( MUR.hideVideo() && !this.isHome ){
			this.$video.remove();
		}
	},

	/*
	 * Prep for re-init
	 * @param	void
	 * @returns void
	 */
	drop:function(){
		this.$video.off('scroll');
		this.$video.off('click');
		this.$playBtn.off('click');
	}
}

module.exports = VideoHero;
